/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LogtoDataMutationPayloadDto = {
    event: LogtoDataMutationPayloadDto.event;
    data: Record<string, any>;
    params: Record<string, any>;
};
export namespace LogtoDataMutationPayloadDto {
    export enum event {
        USER_CREATED = 'User.Created',
        USER_DELETED = 'User.Deleted',
        USER_DATA_UPDATED = 'User.Data.Updated',
        USER_SUSPENSION_STATUS_UPDATED = 'User.SuspensionStatus.Updated',
        ORGANIZATION_CREATED = 'Organization.Created',
        ORGANIZATION_DELETED = 'Organization.Deleted',
        ORGANIZATION_DATA_UPDATED = 'Organization.Data.Updated',
    }
}

